import {INIT_SWIPER} from "../js/inits/init.swiper";
import {INIT_TABS} from "../js/inits/init.tabs";

document.addEventListener('DOMContentLoaded', () => {
  INIT_SWIPER();
  INIT_TABS();
});
